import { writable, get, derived } from "svelte/store";
import { supabase, getUserId } from "@helpers/supabaseClient.js";

export const appVersion = '0.1.1'; 
const environment =  __api.env.isProd && 'production' || 'development';

const transforms = {
  topFourDepartments: (items) => items.map((item) => item.Department),
  selectedPerformanceMeasures: (items) => items.map(({ Measure, Department, Division }) => ({Measure, Department, Division})),
  guessIsCorrect: (value) => ({ value }),
  selectedDistrict: (value) => ({ value }),
}
let isVisit = false
const handleSubmissions = async (key, data) => {
  const userId = await getUserId();
  if (!userId) {
    return
  }
  let submission_data = transforms[key] && transforms[key](data) || data
  let { error } = await supabase.from('users_submissions').upsert({
    user_id: userId,
    submission_key: key,
    submission_data,
    app_version: appVersion,
    environment,
  }, {
    returning: 'minimal',
  });
}

const writableLocalStorageStore = (key, startValue) => {
  const store = writable(startValue);
  
  return {
    ...store,
    submit: async () => {
      await handleSubmissions(key, get(store));
    },
    useLocalStorage: async () => {
      const json = localStorage.getItem(key);
      if (json) {
        isVisit = true
        store.set(JSON.parse(json));
      }
      
      store.subscribe(async (current) => {
        localStorage.setItem(key, JSON.stringify(current));
        if (isVisit) {
          isVisit = false
          return
        }
        await handleSubmissions(key, current);
      });
    }
  };
}

export const guessIsCorrect = writableLocalStorageStore('guessIsCorrect', null);
export const topFourDepartments = writableLocalStorageStore('topFourDepartments', []);
export const budgetBlocks = writableLocalStorageStore('budgetBlocks', []);
export const selectedPerformanceMeasures = writableLocalStorageStore('selectedPerformanceMeasures', []);
export const selectedDistrict = writableLocalStorageStore('selectedDistrict', null);

export const latestWorkableStep = derived([
  topFourDepartments,
  budgetBlocks,
  selectedPerformanceMeasures,
], ([
  $topFourDepartments,
  $budgetBlocks,
  $selectedPerformanceMeasures,
]) => {
  if ($topFourDepartments.length == 0) {
    return 'build'
  }

  if ($budgetBlocks.length == 0) {
    return 'blocks'
  }

  if (
    $selectedPerformanceMeasures.length == 0
  ) {
    return 'outcomes'
  }
})

// localStorage.removeItem('guessIsCorrect');
// localStorage.removeItem('topFourDepartments');
// localStorage.removeItem('budgetBlocks');
// localStorage.removeItem('selectedPerformanceMeasures');
// localStorage.removeItem('selectedDistrict');
